export default "__VITE_ASSET__DosgjJzz__"